import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'getKeys',
    standalone: false
})
export class GetKeysPipe implements PipeTransform {
  public transform(value?, args?: string[]): any {
    const keys = [];
    for (const key in value) {
      if (key) {
        keys.push(key);
      }
    }
    return keys;
  }
}
